import type { TNotificationState } from '../utils/types';
import { atom } from 'recoil';

export const notificationState = atom<TNotificationState>({
  key: 'notificationState',
  default: { notifications: [] },
});
